import * as React from "react";
import { Chip } from "@mui/material";
import { Localized } from "@fluent/react";
import { getStatusEntry } from "../utils/documentStatusUi";

type Props = {
    status: string | null | undefined;
    size?: "small" | "medium";
};

export const DocumentStatusChip: React.FC<Props> = ({
    status,
    size = "small"
}) => {
    const entry = getStatusEntry(status);

    return (
        <Chip
            label={<span>
                <Localized id={entry.labelId}>
                    {entry.fallback}
                </Localized></span>
            }
            size={size}
            color={entry.color}
            variant="filled"
            sx={{
                height: size === "small" ? 16 : 20,
            }}
        />

    );
};